<template>
  <div class="">

    <select v-if="order.payment_status.status_id == 2 && (isAdmin || isUserStore)"
            @change="setDataForChangeOrderStatus(order)"
            v-model="order.status.status_id" class="form-control">

      <option class="text-dark" v-for="(order_status_item,index) in getOrderStatus" :value="index">
        {{ order_status_item }}
      </option>

    </select>

    <span v-else>{{ order.status.status_name }}</span>


  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {order_status} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: 'OrderStatusManager1',
  props: {
    order: {}
  },
  data() {
    return {
      order_status,
    }
  },
  computed: {
    ...mapGetters({
      isUserStore: "User/isUserStore",
      isAdmin: "User/isAdmin"
    }),
    getOrderStatus() {
      return this.order_status.filter((item, index) => {
        if (index > 0) {
          return item
        }
      });
    }
  },
  methods: {
    ...mapActions({
      changeOrderStatus: 'ShoppingCart/changeOrderStatus',
    }),
    setDataForChangeOrderStatus(item) {
      const order_id = item.id;
      const status = item.status.status_id;
      this.changeOrderStatus({order_id, status});

    },
  },
  mounted() {
  }
}
</script>


<style scoped>

</style>